
import Vue from "vue";
import { DossierConfigService } from "@/services/dossier-config-service";
import { IComputedEmail, MessagesService } from "@/services/messages-service";
import { Contact, Sale } from "@/models/base";
import { IMail } from "@/utils/mail";
import { MailSettings } from "@/models/mail-settings";
import { MailSettingsService } from "@/services/mail-settings-service";

export default Vue.extend({
	data() {
		return {
			editMessage: false,
			mailData: {
				from: "",
				name: "",
				to: "",
				subject: "",
				body: "",
				attachments: [],
				isHTML: true,
				bcc: "",
				cc: ""
			} as IMail,
			mailSettings: new MailSettings()
		};
	},
	props: {
		link: String,
		contact: Object as ()=> Contact,
		sale: Object as ()=>Sale
	},
	computed: {
		input(): HTMLInputElement {
			return (this.$refs.input as any).inputElement as HTMLInputElement;
		}
	},
	methods: {
		cancel() {
			this.$emit("cancel");
		},
		openPortal() {
			window.open(this.link);
		},
		async send() {
			try {
				await MessagesService.sendMail(this.mailData, this.mailSettings);
				this.$wf.notify(
					this.$ct("success"),
					"success",
					3500,
					"exclamation-triangle"
				);
				this.$emit("cancel");
			} catch (e) {
				this.$wf.notify(
					this.$ct("error.500"),
					"danger",
					3500,
					"exclamation-triangle"
				);
			}
		},
		isAllowed(): Boolean {
			return true;
			//return AuthService.hasModule(83);
		},
		async fetchDataFromNormalTemplate(){
			let r = await MessagesService.getComputedPortalMail(this.contact);
			this.onComputedEmail(r);
		},
		async fetchDataFromSaleTemplate(){
			if (!this.sale) return;
			let config = await DossierConfigService.getSaleConfig(this.sale.TypeID);
			if (config.DefaultPortalEmailTemplateID == 0){
				this.fetchDataFromNormalTemplate();
				return;
			};
			let template = await MessagesService.getSaleEmailTemplateByIDOrFirst(config.DefaultPortalEmailTemplateID);
			let r = await MessagesService.getComputedSaleMail(template, this.sale);
			this.onComputedEmail(r);
		},
		async onComputedEmail(email:IComputedEmail){
			if (!this.mailSettings) return;
			this.mailData.body = `${email.Body}\n${
				this.mailSettings.Signature
			}`;
			if (!this.mailData.from || this.mailData.from.match(/^\s*$/)) {
				this.mailData.from = this.mailSettings.EmailFrom || this.mailSettings.Email;
				this.mailData.name = this.mailSettings.EmailName;
			}
			this.mailData.bcc = this.mailSettings.DefaultBCCEmail || "";
			this.mailData.cc = this.mailSettings.DefaultCCEmail || "";
			if (this.contact.MainAddress) {
				this.mailData.to = this.contact.MainAddress.Email;
			}
			this.mailData.subject = email.Subject;
		}
	},
	async mounted() {
		this.mailSettings = await MailSettingsService.getDefaultSettings();
		if (this.sale){
			await this.fetchDataFromSaleTemplate();
		}else{
			await this.fetchDataFromNormalTemplate();
		}
	},
	components: {
		VueEditor: () => import("@/utils/vue-editor")
	},
	i18nEx: {
		componentPrefix: "components.client-portal.modal"
	}
});
